import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { doc, setDoc, getDocs, collection, query, where, orderBy, limit, serverTimestamp, Timestamp } from "firebase/firestore";
import { checkBankBalance, formatTry as formatBankTry } from "../utils/bankBalanceCheck";
import { db } from "../firebase";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import GunsonuWhatsappSendDialog from "../components/GunsonuWhatsappSendDialog";

function GunSonuKasa({ sube: subeProp }) {
  const navigate = useNavigate();
  const sube = subeProp ? subeProp.trim() : "";

  // TAKI ÜRÜN BURADA YOK (Doğru)
  const [formData, setFormData] = useState({
    sarrafiye: {
      eskiZiynetCeyrek: { adet: 0 },
      yeniZiynetCeyrek: { adet: 0 },
      eskiZiynetYarim: { adet: 0 },
      yeniZiynetYarim: { adet: 0 },
      eskiZiynetTam: { adet: 0 },
      yeniZiynetTam: { adet: 0 },
      eskiZiynetGremse: { adet: 0 },
      yeniZiynetGremse: { adet: 0 },
      eskiZiynetBesli: { adet: 0 },
      yeniZiynetBesli: { adet: 0 },
      cumhuriyetAtaCeyrek: { adet: 0 },
      cumhuriyetAtaYarim: { adet: 0 },
      cumhuriyetAta: { adet: 0 },
      cumhuriyetAtaGremse: { adet: 0 },
      cumhuriyetAtaBesli: { adet: 0 },
      resatCeyrek: { adet: 0 },
      resatYarim: { adet: 0 },
      resat: { adet: 0 },
      resatGremse: { adet: 0 },
      resatBesli: { adet: 0 }
    },
    gramAltin: {
      birGram22Ayar: { adet: 0 },
      yariGram22Ayar: { adet: 0 },
      ceyrekGram22Ayar: { adet: 0 },
      birGram24Ayar: { adet: 0 },
      yariGram24Ayar: { adet: 0 },
      ceyrekGram24Ayar: { adet: 0 },
      ikiBucukGram24Ayar: { adet: 0 },
      besGram24Ayar: { adet: 0 },
      onGram24Ayar: { adet: 0 },
      yirmiGram24Ayar: { adet: 0 },
      elliGram24Ayar: { adet: 0 },
      yuzGram24Ayar: { adet: 0 }
    },
    hurda: {
      yirmiDortAyarHurda: { gram: 0 },
      yirmiIkiAyarBilezikHurda: { gram: 0 },
      yirmiIkiAyarHurda: { gram: 0 },
      yirmiBirAyarHurda: { gram: 0 },
      onSekizAyarHurda: { gram: 0 },
      onDortAyarHurda: { gram: 0 },
      sekizAyarHurda: { gram: 0 }
    },
    doviz: {
      tl: { adet: 0 },
      usd: { adet: 0 },
      eur: { adet: 0 },
      gbp: { adet: 0 },
      chf: { adet: 0 },
      aud: { adet: 0 },
      cad: { adet: 0 },
      sar: { adet: 0 },
      aed: { adet: 0 },
      qar: { adet: 0 },
      mad: { adet: 0 },
      jod: { adet: 0 },
      kwd: { adet: 0 },
      cny: { adet: 0 },
      rub: { adet: 0 },
      bgn: { adet: 0 }
    }
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [validationError, setValidationError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState([]);
  const [whatsappOpen, setWhatsappOpen] = useState(false);
  const [whatsappInstantSend, setWhatsappInstantSend] = useState(false);
  const [savedKasaData, setSavedKasaData] = useState(null);
  // Gun sonunda kasa gibi banka da kontrol edilir: canli bakiye ile sistemdeki
  // havale/EFT toplami tutmuyorsa kayit engellenir (kullanici karari 2026-09-29).
  const [bankCheck, setBankCheck] = useState(null);
  const [bankCheckLoading, setBankCheckLoading] = useState(false);

  const categories = [
    {
      key: "sarrafiye",
      name: "Sarrafiye",
      field: "adet",
      fieldLabel: "Adet",
      productWidth: "265px",
      totalWidth: "335px",
      items: [
        { key: "eskiZiynetCeyrek", label: "Eski Ziynet Çeyrek" },
        { key: "yeniZiynetCeyrek", label: "Yeni Ziynet Çeyrek" },
        { key: "eskiZiynetYarim", label: "Eski Ziynet Yarım" },
        { key: "yeniZiynetYarim", label: "Yeni Ziynet Yarım" },
        { key: "eskiZiynetTam", label: "Eski Ziynet Tam" },
        { key: "yeniZiynetTam", label: "Yeni Ziynet Tam" },
        { key: "eskiZiynetGremse", label: "Eski Ziynet 2.5'lu Gremse" },
        { key: "yeniZiynetGremse", label: "Yeni Ziynet 2.5'lu Gremse" },
        { key: "eskiZiynetBesli", label: "Eski Ziynet Beşli" },
        { key: "yeniZiynetBesli", label: "Yeni Ziynet Beşli" },
        { key: "cumhuriyetAtaCeyrek", label: "Cumhuriyet Ata Çeyrek" },
        { key: "cumhuriyetAtaYarim", label: "Cumhuriyet Ata Yarım" },
        { key: "cumhuriyetAta", label: "Cumhuriyet Ata" },
        { key: "cumhuriyetAtaGremse", label: "Cumhuriyet Ata 2.5'lu Gremse" },
        { key: "cumhuriyetAtaBesli", label: "Cumhuriyet Ata Besli" },
        { key: "resatCeyrek", label: "Reşat Çeyrek" },
        { key: "resatYarim", label: "Reşat Yarım" },
        { key: "resat", label: "Reşat" },
        { key: "resatGremse", label: "Reşat 2.5'lu Gremse" },
        { key: "resatBesli", label: "Reşat Besli" }
      ]
    },
    {
      key: "gramAltin",
      name: "Gram Altın",
      field: "adet",
      fieldLabel: "Adet",
      productWidth: "185px",
      totalWidth: "255px",
      items: [
        { key: "birGram22Ayar", label: "1 Gram 22 Ayar" },
        { key: "yariGram22Ayar", label: "0.50 Gram 22 Ayar" },
        { key: "ceyrekGram22Ayar", label: "0.25 Gram 22 Ayar" },
        { key: "birGram24Ayar", label: "1 Gram 24 Ayar" },
        { key: "yariGram24Ayar", label: "0.50 Gram 24 Ayar" },
        { key: "ceyrekGram24Ayar", label: "0.25 Gram 24 Ayar" },
        { key: "ikiBucukGram24Ayar", label: "2.50 Gram 24 Ayar" },
        { key: "besGram24Ayar", label: "5 Gram 24 Ayar" },
        { key: "onGram24Ayar", label: "10 Gram 24 Ayar" },
        { key: "yirmiGram24Ayar", label: "20 Gram 24 Ayar" },
        { key: "elliGram24Ayar", label: "50 Gram 24 Ayar" },
        { key: "yuzGram24Ayar", label: "100 Gram 24 Ayar" }
      ]
    },
    {
      key: "hurda",
      name: "Hurda",
      field: "gram",
      fieldLabel: "Gram",
      productWidth: "205px",
      totalWidth: "270px",
      items: [
        { key: "yirmiDortAyarHurda", label: "24 Ayar Hurda" },
        { key: "yirmiIkiAyarBilezikHurda", label: "22 Ayar Bilezik Hurda" },
        { key: "yirmiIkiAyarHurda", label: "22 Ayar Hurda" },
        { key: "yirmiBirAyarHurda", label: "21 Ayar Hurda" },
        { key: "onSekizAyarHurda", label: "18 Ayar Hurda" },
        { key: "onDortAyarHurda", label: "14 Ayar Hurda" },
        { key: "sekizAyarHurda", label: "8 Ayar Hurda" }
      ]
    },
    {
      key: "doviz",
      name: "Döviz",
      field: "adet",
      fieldLabel: "Birim",
      productWidth: "325px",
      totalWidth: "400px",
      items: [
        { key: "tl", label: "TL - Türk Lirası" },
        { key: "usd", label: "USD - Amerikan Doları" },
        { key: "eur", label: "EUR - Euro" },
        { key: "gbp", label: "GBP - İngiliz Sterlini" },
        { key: "chf", label: "CHF - İsviçre Frangı" },
        { key: "aud", label: "AUD - Avustralya Doları" },
        { key: "cad", label: "CAD - Kanada Doları" },
        { key: "sar", label: "SAR - Suudi Arabistan Riyali" },
        { key: "aed", label: "AED - Birleşik Arap Emirlikleri Dirhemi" },
        { key: "qar", label: "QAR - Katar Riyali" },
        { key: "mad", label: "MAD - Fas Dirhemi" },
        { key: "jod", label: "JOD - Ürdün Dinarı" },
        { key: "kwd", label: "KWD - Kuveyt Dinarı" },
        { key: "cny", label: "CNY - Çin Yuanı" },
        { key: "rub", label: "RUB - Rus Rublesi" },
        { key: "bgn", label: "BGN - Bulgar Levası" }
      ]
    }
  ];

  const normalizeString = (str) => {
    return str ? str.trim().toLocaleLowerCase('tr-TR').replace(/\s+/g, " ") : "";
  };

  useEffect(() => {
    if (!sube) {
      setError("Şube bilgisi eksik.");
      setLoading(false);
      return;
    }
    setLoading(false);
  }, [sube, navigate]);

  useEffect(() => {
    if (!sube) return;
    let iptal = false;
    setBankCheckLoading(true);
    checkBankBalance(sube)
      .then((sonuc) => {
        if (!iptal) setBankCheck(sonuc);
      })
      .catch((err) => {
        if (!iptal) setBankCheck({ ok: false, blocking: false, reason: err?.message || "Banka kontrolü yapılamadı." });
      })
      .finally(() => {
        if (!iptal) setBankCheckLoading(false);
      });
    return () => {
      iptal = true;
    };
  }, [sube]);

  useEffect(() => {
    if (validationError) {
      const errorLines = validationError.split(", ").map((line) => line.trim());
      // Artik banka farki da bu listeye dusebiliyor; baslik ona gore secilir.
      const sadeceBanka = errorLines.every((line) => line.startsWith("Banka:"));
      setModalMessage([
        sadeceBanka ? "Hata: Banka bakiyesi tutmuyor:" : "Hata: Şu ürünlerde uyumsuzluk var:",
        ...errorLines,
        sadeceBanka
          ? "Banka hareketleri kasaya doğru girilmeden gün sonu kaydedilemez."
          : "Lütfen sayımı tekrar yapın."
      ]);
      setShowModal(true);
      return;
    }
    if (error) {
      setModalMessage([error]);
      setShowModal(true);
    }
  }, [error, validationError]);

  useEffect(() => {
    if (!success || !savedKasaData) return;
    setWhatsappInstantSend(false);
    setWhatsappOpen(true);
  }, [success, savedKasaData]);

  /** Anlık WhatsApp PDF — Mevcut Kasa bazlı (kaydetmez). */
  const openInstantWhatsappPdf = () => {
    setSavedKasaData({ ...formData, sube });
    setWhatsappInstantSend(true);
    setWhatsappOpen(true);
  };

  const closeWhatsappDialog = () => {
    setWhatsappOpen(false);
    setWhatsappInstantSend(false);
    setSuccess("");
  };

  const handleInputChange = (categoryKey, itemKey, field, e) => {
    const rawValue = e.target.value;
    const isDecimalField = categoryKey === "hurda";
    const normalizedValue = rawValue.replace(",", ".");
    const validPattern = isDecimalField ? /^\d*(\.\d{0,2})?$/ : /^\d*$/;

    // Kullanıcı "0.20" gibi değerleri adım adım yazabilsin
    if (rawValue !== "" && !validPattern.test(normalizedValue)) return;

    setFormData((prev) => ({
      ...prev,
      [categoryKey]: {
        ...prev[categoryKey],
        [itemKey]: { [field]: rawValue === "" ? 0 : normalizedValue },
      },
    }));
  };

  const validateKasa = async () => {
    try {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const todayTimestamp = Timestamp.fromDate(today);

      const gunsonuQuery = query(
        collection(db, "subeler", sube, "gunsonukasa"),
        where("timestamp", "<", todayTimestamp),
        orderBy("timestamp", "desc"),
        limit(1)
      );
      const gunsonuSnapshot = await getDocs(gunsonuQuery);
      let dunkuKapanis = {};
      if (!gunsonuSnapshot.empty) {
        dunkuKapanis = gunsonuSnapshot.docs[0].data();
      }

      const lastGunsonuTimestamp = dunkuKapanis.timestamp || new Timestamp(0, 0);
      const islemQuery = query(
        collection(db, "subeler", sube, "islemler"),
        where("timestamp", ">=", lastGunsonuTimestamp),
        orderBy("timestamp", "asc")
      );
      const querySnapshot = await getDocs(islemQuery);
      const islemler = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
        timestamp: doc.data().timestamp instanceof Timestamp ? doc.data().timestamp.toDate().toISOString() : doc.data().timestamp,
      }));

      const beklenenKasa = {};
      categories.forEach((category) => {
        beklenenKasa[category.key] = {};
        category.items.forEach((item) => {
          beklenenKasa[category.key][item.key] = { [category.field]: 0 };
        });
      });

      categories.forEach((category) => {
        category.items.forEach((item) => {
          const dunkuDeger = dunkuKapanis[category.key]?.[item.key]?.[category.field] || 0;
          beklenenKasa[category.key][item.key][category.field] = Number(dunkuDeger);
        });
      });

      islemler.forEach((islem) => {
        const islemUrun = normalizeString(islem.urun);
        const islemKategori = normalizeString(islem.kategori);
        const isTL = islem.kategori === "Döviz" && islem.urun === "TL - Türk Lirası";
        const gramMiktar = parseFloat(islem.gram) || 0;
        const adetMiktar = parseInt(islem.adet) || 0;
        const nakitMiktar = parseFloat(islem.nakit) || 0;
        
        // --- YENİ EKLENEN KONTROL: Teslimat Bekliyor mu? ---
        // Eğer "Teslimat Bekliyor" ise ürün henüz kasadan çıkmamıştır.
        // Bu yüzden Satış bile olsa stoktan düşülmez (sanki hiç satılmamış gibi sayılır).
        const isTeslimatBekliyor = islem.teslimatDurumu === "Teslimat Bekliyor";

        // ------------------------------------------------------------------
        // 1. ADIM: EVRENSEL NAKİT (TL) HESAPLAMASI (KATEGORİDEN BAĞIMSIZ)
        // ------------------------------------------------------------------
        if (nakitMiktar > 0) {
            if (!beklenenKasa.doviz) beklenenKasa.doviz = {};
            if (!beklenenKasa.doviz.tl) beklenenKasa.doviz.tl = { adet: 0 };

            // Nakit yonu Mevcut Kasa ile birebir ayni olmali (mevcutkasa.js /
            // mevcutKasaService.js). Urunun kendisi TL ise nakit, isin yonunu
            // dogrudan verir: TL alinca kasaya girer, TL verince cikar. Baska
            // bir urunse nakit o urunun karsiligidir, yon terstir.
            if (["Alış", "İade", "Değişim", "Giriş"].includes(islem.islemTuru)) {
               if (isTL) beklenenKasa.doviz.tl.adet += nakitMiktar;
               else beklenenKasa.doviz.tl.adet -= nakitMiktar;
            }
            else if (["Satış", "Çıkış"].includes(islem.islemTuru)) {
               if (isTL) beklenenKasa.doviz.tl.adet -= nakitMiktar;
               else beklenenKasa.doviz.tl.adet += nakitMiktar;
            }
        }

        // ------------------------------------------------------------------
        // 2. ADIM: STOK HESAPLAMASI (LİSTEDEKİ KATEGORİLER İÇİN)
        // ------------------------------------------------------------------
        categories.forEach((category) => {
          const categoryName = normalizeString(category.name);
          if (islemKategori === categoryName) {
            category.items.forEach((item) => {
              const itemLabel = normalizeString(item.label);
              if (islemUrun === itemLabel) {
                
                if (item.key === "tl") return;

                if (islem.islemTuru === "Alış" || islem.islemTuru === "İade" || islem.islemTuru === "Değişim" || islem.islemTuru === "Giriş") {
                  if (category.key === "sarrafiye" || category.key === "gramAltin") {
                    beklenenKasa[category.key][item.key].adet += adetMiktar;
                  } else if (category.key === "hurda") {
                    beklenenKasa[category.key][item.key].gram += gramMiktar;
                  } else if (category.key === "doviz") {
                    beklenenKasa[category.key][item.key].adet += adetMiktar;
                  }
                } 
                // --- DÜZELTME BURADA YAPILDI ---
                // Satış/Çıkış işleminde: Eğer "Teslimat Bekliyor" ise düşme!
                else if ( (islem.islemTuru === "Satış" || islem.islemTuru === "Çıkış") && !isTeslimatBekliyor ) {
                  if (category.key === "sarrafiye" || category.key === "gramAltin") {
                    beklenenKasa[category.key][item.key].adet -= adetMiktar;
                  } else if (category.key === "hurda") {
                    beklenenKasa[category.key][item.key].gram -= gramMiktar;
                  } else if (category.key === "doviz") {
                    beklenenKasa[category.key][item.key].adet -= adetMiktar;
                  }
                }
                
                if (category.key === "hurda") {
                  beklenenKasa[category.key][item.key].gram = Number(beklenenKasa[category.key][item.key].gram.toFixed(2));
                }
                if (category.key === "doviz") {
                  beklenenKasa[category.key][item.key].adet = Number(beklenenKasa[category.key][item.key].adet.toFixed(2));
                }
              }
            });
          }
        });
      });

      let errors = [];
      categories.forEach((category) => {
        category.items.forEach((item) => {
          const girilenDeger = formData[category.key][item.key][category.field] || 0;
          const beklenenDeger = beklenenKasa[category.key][item.key][category.field] || 0;
          
          if (Math.abs(girilenDeger - beklenenDeger) > 0.01) {
            const fark = girilenDeger - beklenenDeger;
            errors.push(`${item.label}: ${fark > 0 ? "Fazla" : "Eksik"} ${Math.abs(fark).toFixed(category.key === "hurda" || category.key === "doviz" ? 2 : 0)} ${category.fieldLabel}`);
          }
        });
      });

      // Banka kontrolu: kasa sayimi tuttuysa banka da tutmali. Bakiye
      // okunamazsa (servis kapali vb.) gun sonu kilitlenmesin, sadece fark
      // varken engellenir.
      const banka = await checkBankBalance(sube);
      setBankCheck(banka);
      if (banka.blocking) {
        errors.push(
          `Banka: canlı ${formatBankTry(banka.liveTotal)} · sistem ${formatBankTry(banka.systemTotal)} · fark ${formatBankTry(banka.diff)}`
        );
      }

      if (errors.length > 0) {
        setValidationError(errors.join(", "));
        return false;
      }
      return true;
    } catch (err) {
      setValidationError(`Doğrulama hatası: ${err.message}`);
      return false;
    }
  };

  const handleSubmit = async () => {
    setValidationError("");
    setError("");
    setSuccess("");
    const isValid = await validateKasa();
    if (!isValid) return;

    try {
      const today = new Date().toISOString().split("T")[0];
      const docRef = doc(db, "subeler", sube, "gunsonukasa", today);

      const finalData = {
        ...formData,
        sube: sube,
        timestamp: serverTimestamp(),
      };
      // O aksam bankada ne vardi: geriye donuk bakabilmek icin kayda da yazilir.
      if (bankCheck && bankCheck.liveTotal != null) {
        finalData.banka = {
          canliToplam: bankCheck.liveTotal,
          sistemToplam: bankCheck.systemTotal,
          fark: bankCheck.diff,
          hesaplar: (bankCheck.live?.accounts || [])
            .filter((a) => a.ok)
            .map((a) => ({ banka: a.label, bakiye: a.balance }))
        };
      }

      await setDoc(docRef, finalData, { merge: true });
      setSavedKasaData(finalData);
      setSuccess("Sayım başarıyla kaydedildi.");

      setFormData((prev) => ({
        ...prev,
        sarrafiye: Object.fromEntries(Object.keys(prev.sarrafiye).map((k) => [k, { adet: 0 }])),
        gramAltin: Object.fromEntries(Object.keys(prev.gramAltin).map((k) => [k, { adet: 0 }])),
        hurda: Object.fromEntries(Object.keys(prev.hurda).map((k) => [k, { gram: 0 }])),
        doviz: Object.fromEntries(Object.keys(prev.doviz).map((k) => [k, { adet: 0 }])),
      }));
    } catch (err) {
      setError(`Hata: ${err.message}`);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setModalMessage([]);
    setError("");
    setValidationError("");
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontFamily: "'Roboto', sans-serif",
        }}
      >
        <p
          style={{
            fontSize: "16px",
            color: "#4b5563",
            fontWeight: "bold",
            padding: "10px 20px",
            backgroundColor: "#ffffff",
            borderRadius: "6px",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          Yükleniyor...
        </p>
      </div>
    );
  }

  return (
    <div
      className="gsk-page"
      style={{
        background: "linear-gradient(180deg, #f8fafd 0%, #eff3f8 100%)",
        borderRadius: "12px",
        padding: "8px 10px 10px",
        boxShadow: "0 10px 24px rgba(15, 23, 42, 0.10)",
        border: "1px solid #d9e2ee",
        width: "1500px",
        height: "735px",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        fontFamily: "'Roboto', sans-serif",
        margin: "-10px 0 4px 0",
        position: "relative",
      }}
    >
      <Dialog open={showModal} onClose={closeModal} PaperProps={{ className: 'gsk-dialog', style: { borderRadius: "12px", border: "1px solid #dce5f1", boxShadow: "0 14px 28px rgba(15, 23, 42, 0.2)", background: "linear-gradient(180deg, #ffffff 0%, #f6f9ff 100%)" } }}>
        <DialogTitle style={{ fontFamily: "'Roboto', sans-serif", fontWeight: "bold", fontSize: "18px", color: "#102a43" }}>
          Hata
        </DialogTitle>
        <DialogContent>
          {modalMessage.map((line, index) => (
            <p
              key={index}
              style={{
                fontSize: "15px",
                color: "#dc2626",
                fontWeight: "bold",
                margin: "5px 0",
              }}
            >
              {line}
            </p>
          ))}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={closeModal}
            style={{
              fontFamily: "'Roboto', sans-serif",
              fontWeight: "bold",
              color: "#27476b",
              fontSize: "13px",
              border: "1px solid #27476b",
              borderRadius: "8px",
              padding: "4px 12px",
            }}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>

      <GunsonuWhatsappSendDialog
        open={whatsappOpen}
        onClose={closeWhatsappDialog}
        sube={sube}
        kasaData={savedKasaData}
        instantSend={whatsappInstantSend}
      />
      <div
        className="gsk-header"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "0 4px 6px",
          padding: "4px 8px",
          borderBottom: "1px solid #dbe4ef",
        }}
      >
        <h2 className="gsk-title" style={{ margin: 0, fontSize: "18px", fontWeight: 800, color: "#1e293b", letterSpacing: "0.2px" }}>
          Gün sonu kasa
        </h2>
        <span className="gsk-date" style={{ fontSize: "13px", color: "#64748b", fontWeight: 700 }}>
          {new Date().toLocaleDateString("tr-TR", { day: "2-digit", month: "long", year: "numeric", weekday: "long" })}
        </span>
      </div>

      {/* Banka kontrolu: kasadaki urunler gibi banka da gun sonunda dogrulanir. */}
      <div
        className="gsk-bank-strip"
        style={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "6px 14px",
          margin: "0 4px 6px",
          padding: "5px 10px",
          borderRadius: "8px",
          fontSize: "12.5px",
          fontWeight: 700,
          border: `1px solid ${bankCheck?.blocking ? "#fecaca" : bankCheck?.ok ? "#bbf7d0" : "#e2e8f0"}`,
          background: bankCheck?.blocking ? "#fef2f2" : bankCheck?.ok ? "#f0fdf4" : "#f8fafc",
          color: "#334155",
        }}
      >
        <span style={{ color: "#0f172a", letterSpacing: "0.03em" }}>BANKA</span>
        {bankCheckLoading ? (
          <span style={{ color: "#64748b", fontWeight: 600 }}>bakiye kontrol ediliyor…</span>
        ) : bankCheck?.liveTotal == null ? (
          <span style={{ color: "#b45309", fontWeight: 600 }}>
            {bankCheck?.reason || "Banka bakiyesi okunamadı; bu kontrol atlanacak."}
          </span>
        ) : (
          <>
            {(bankCheck.live?.accounts || [])
              .filter((a) => a.ok)
              .map((a) => (
                <span key={a.provider} style={{ color: "#475569", fontWeight: 600 }}>
                  {a.label} {formatBankTry(a.balance)}
                </span>
              ))}
            <span>Bankada {formatBankTry(bankCheck.liveTotal)}</span>
            <span>Sistemde {formatBankTry(bankCheck.systemTotal)}</span>
            <span style={{ color: bankCheck.ok ? "#15803d" : "#b91c1c" }}>
              {bankCheck.ok ? "Uyumlu ✓" : `Fark ${formatBankTry(bankCheck.diff)} — gün sonu kaydedilemez`}
            </span>
          </>
        )}
      </div>
      <div
        className="gsk-columns"
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          overflow: "hidden",
          boxSizing: "border-box",
          flex: "1",
          justifyContent: "center",
          marginLeft: "0",
          marginTop: "0",
        }}
      >
        {categories.map((category) => (
          <div
            key={category.key}
            className="gsk-col"
            data-kategori={category.key}
            style={{
              width: category.totalWidth,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              boxSizing: "border-box",
              background: "#ffffff",
              border: "1px solid #dfe7f2",
              borderRadius: "8px",
              boxShadow: "0 4px 10px rgba(15, 23, 42, 0.05)",
            }}
          >
            <h3 style={{ fontSize: "12px", fontWeight: 800, margin: "0", padding: "5px 6px", color: "#334155", borderBottom: "1px solid #e5ebf3", background: "#f8fbff" }}>{category.name}</h3>
            <table
              className="gsk-table"
              style={{
                width: "100%",
                borderCollapse: "separate",
                borderSpacing: "0",
                fontSize: "11px",
                color: "#1f2937",
                lineHeight: "1.2",
                boxSizing: "border-box",
                fontWeight: "700",
              }}
            >
              <thead>
                <tr>
                  <th style={{ border: "1px solid #e5e7eb", borderBottom: "1px solid #c58a2f", padding: "4px 5px", width: category.productWidth, fontWeight: "800", fontSize: "11px", textAlign: "left", background: "#f3f7fd" }}>
                    Ürün
                  </th>
                  <th style={{ border: "1px solid #e5e7eb", borderBottom: "1px solid #c58a2f", padding: "4px 4px", width: "60px", fontWeight: "800", fontSize: "11px", textAlign: "center", background: "#f3f7fd" }}>
                    {category.fieldLabel}
                  </th>
                </tr>
              </thead>
              <tbody>
                {category.items.map((item) => (
                  <tr key={item.key}>
                    <td
                      style={{
                        border: "1px solid #e5e7eb",
                        borderRight: "1px solid #e5e7eb",
                        padding: "3px 5px",
                        width: category.productWidth,
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                        boxSizing: "border-box",
                        fontWeight: 700,
                        fontSize: "14px",
                        color: "#0f172a",
                      }}
                    >
                      {item.label}
                    </td>
                    <td
                      style={{
                        border: "1px solid #e5e7eb",
                        borderRight: "1px solid #e5e7eb",
                        padding: "3px",
                        width: "60px",
                        boxSizing: "border-box",
                      }}
                    >
                      <input
                        type="number"
                        step={category.key === "hurda" ? "0.01" : "1"}
                        value={formData[category.key][item.key][category.field] === 0 ? "" : formData[category.key][item.key][category.field]}
                        onFocus={(e) => {
                          if (e.target.value === "") e.target.value = "";
                        }}
                        onBlur={(e) => {
                          if (e.target.value === "") {
                            handleInputChange(category.key, item.key, category.field, { target: { value: "0" } });
                          }
                        }}
                        onChange={(e) => handleInputChange(category.key, item.key, category.field, e)}
                        placeholder="0"
                        className="gsk-input"
                        style={{
                          width: "100%",
                          padding: "2px 3px",
                          fontSize: "15px",
                          fontFamily: "'Roboto', sans-serif",
                          border: "1px solid #d4dcea",
                          borderRadius: "4px",
                          outline: "none",
                          boxSizing: "border-box",
                          fontWeight: 700,
                          appearance: "none",
                          WebkitAppearance: "none",
                          MozAppearance: "none",
                          background: "#ffffff",
                          textAlign: "center",
                        }}
                      />
                      <style>{`
                        .gsk-input::-webkit-inner-spin-button,
                        .gsk-input::-webkit-outer-spin-button {
                          -webkit-appearance: none;
                          margin: 0;
                        }
                        .gsk-input:focus {
                          border-color: #b47a2a !important;
                          box-shadow: 0 0 0 2px rgba(180, 122, 42, 0.12);
                        }
                        .gsk-table tbody tr:nth-child(odd) td {
                          background: #fcfdff;
                        }
                      `}</style>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
      <div
        className="gsk-submit-wrap"
        style={{
          marginTop: "0",
          textAlign: "right",
          position: "absolute",
          right: "6px",
          top: "50%",
          transform: "translateY(-50%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <button
          className="gsk-submit-btn"
          onClick={handleSubmit}
          style={{
            padding: "8px 14px",
            fontSize: "19px",
            fontFamily: "'Roboto', sans-serif",
            background: "linear-gradient(135deg, #12a36b 0%, #0f7f56 100%)",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: "bold",
            writingMode: "vertical-rl",
            textOrientation: "mixed",
            letterSpacing: "0.4px",
            boxShadow: "0 8px 16px rgba(15, 127, 86, 0.28)",
            minWidth: "48px",
            minHeight: "140px",
          }}
        >
          Kaydet
        </button>
        {/* Anlık WhatsApp PDF — Mevcut Kasa bazlı */}
        <button
          type="button"
          onClick={openInstantWhatsappPdf}
          title="Mevcut Kasa bazlı PDF'i WhatsApp'a gönder"
          style={{
            padding: "8px 10px",
            fontSize: "11px",
            fontFamily: "'Roboto', sans-serif",
            background: "linear-gradient(135deg, #27476b 0%, #1e3a5f 100%)",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: "bold",
            writingMode: "vertical-rl",
            textOrientation: "mixed",
            letterSpacing: "0.3px",
            boxShadow: "0 6px 12px rgba(30, 58, 95, 0.25)",
            minWidth: "40px",
            minHeight: "110px",
          }}
        >
          WhatsApp PDF
        </button>
      </div>

      <style>{`
        /* --- TELEFON (<=560px): gun sonu sayimi tek ekrana yaklassin ---
           Satirlar 48px'ti, 55 urun 3.9 ekran ediyordu. Satir yuksekligi
           dusuruldu; isimleri kisa olan Gram Altin / Hurda / Doviz panelleri
           iki sutuna dizildi. Sarrafiye isimleri uzun oldugu icin tek sutun. */
        @media (max-width: 560px) {
          .gsk-page .gsk-col h3 {
            position: sticky;
            top: 0;
            z-index: 2;
            padding: 6px 8px !important;
            font-size: 12.5px !important;
          }

          .gsk-page .gsk-table th,
          .gsk-page .gsk-table td {
            padding: 2px 6px !important;
          }

          .gsk-page .gsk-table td:first-child {
            font-size: 12px !important;
            line-height: 1.15 !important;
          }

          .gsk-page .gsk-table input {
            height: 30px !important;
            font-size: 13px !important;
            padding: 2px 6px !important;
          }

          .gsk-page .gsk-col[data-kategori="sarrafiye"] .gsk-table thead,
          .gsk-page .gsk-col[data-kategori="gramAltin"] .gsk-table thead,
          .gsk-page .gsk-col[data-kategori="hurda"] .gsk-table thead,
          .gsk-page .gsk-col[data-kategori="doviz"] .gsk-table thead {
            display: none;
          }

          .gsk-page .gsk-col[data-kategori="sarrafiye"] .gsk-table tbody,
          .gsk-page .gsk-col[data-kategori="gramAltin"] .gsk-table tbody,
          .gsk-page .gsk-col[data-kategori="hurda"] .gsk-table tbody,
          .gsk-page .gsk-col[data-kategori="doviz"] .gsk-table tbody {
            display: grid;
            grid-template-columns: 1fr 1fr;
            column-gap: 6px;
          }

          .gsk-page .gsk-col[data-kategori="sarrafiye"] .gsk-table tbody tr,
          .gsk-page .gsk-col[data-kategori="gramAltin"] .gsk-table tbody tr,
          .gsk-page .gsk-col[data-kategori="hurda"] .gsk-table tbody tr,
          .gsk-page .gsk-col[data-kategori="doviz"] .gsk-table tbody tr {
            display: grid;
            grid-template-columns: minmax(0, 1fr) 58px;
            align-items: center;
            border-bottom: 1px solid #eef2f7;
          }

          .gsk-page .gsk-col[data-kategori="sarrafiye"] .gsk-table tbody td,
          .gsk-page .gsk-col[data-kategori="gramAltin"] .gsk-table tbody td,
          .gsk-page .gsk-col[data-kategori="hurda"] .gsk-table tbody td,
          .gsk-page .gsk-col[data-kategori="doviz"] .gsk-table tbody td {
            width: auto !important;
            min-width: 0 !important;
            border: none !important;
            padding: 2px 4px !important;
            font-size: 11px !important;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            line-height: 1.1;
          }

          .gsk-page .gsk-col[data-kategori="sarrafiye"] .gsk-table tbody input,
          .gsk-page .gsk-col[data-kategori="gramAltin"] .gsk-table tbody input,
          .gsk-page .gsk-col[data-kategori="hurda"] .gsk-table tbody input,
          .gsk-page .gsk-col[data-kategori="doviz"] .gsk-table tbody input {
            width: 100% !important;
            min-width: 0 !important;
            height: 28px !important;
            padding: 2px 4px !important;
            text-align: center;
          }
        }

        /* --- MOBİL: Günsonu Kasa (masaüstü inline stillere dokunulmaz) --- */
        /* Kompakt duzen: telefonlar + dokunmatik tabletler. Genis cok sutunlu
           yerlesim tablette 700px+ tasiyordu. 'any-pointer: coarse' sayesinde
           fare kullanan masaustu bu blogu hic okumaz. */
        @media (max-width: 1649px), (max-width: 1400px) and (any-pointer: coarse) {
          .gsk-page {
            width: 100% !important;
            max-width: 100% !important;
            height: auto !important;
            min-height: 0 !important;
            margin: 0 !important;
            padding: 10px 8px 14px !important;
            overflow-x: hidden !important;
            box-sizing: border-box !important;
          }

          .gsk-header {
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 4px !important;
            margin: 0 0 10px !important;
            padding: 0 2px 8px !important;
          }

          .gsk-title {
            font-size: 17px !important;
          }

          .gsk-date {
            font-size: 12px !important;
            line-height: 1.35 !important;
          }

          .gsk-columns {
            flex-direction: column !important;
            overflow: visible !important;
            gap: 12px !important;
            width: 100% !important;
            margin: 0 !important;
          }

          .gsk-col {
            width: 100% !important;
            max-width: 100% !important;
            overflow: visible !important;
          }

          .gsk-col h3 {
            font-size: 13px !important;
            padding: 7px 8px !important;
          }

          .gsk-table {
            font-size: 12px !important;
          }

          .gsk-table th,
          .gsk-table td {
            padding: 5px 6px !important;
          }

          .gsk-table th:first-child,
          .gsk-table td:first-child {
            width: auto !important;
          }

          .gsk-table th:last-child,
          .gsk-table td:last-child {
            width: 76px !important;
            min-width: 76px !important;
          }

          .gsk-table td:first-child {
            font-size: 13px !important;
            line-height: 1.25 !important;
          }

          .gsk-input {
            font-size: 16px !important;
            padding: 6px 4px !important;
            min-height: 36px !important;
          }

          .gsk-submit-wrap {
            position: static !important;
            transform: none !important;
            margin-top: 14px !important;
            text-align: center !important;
            padding: 0 2px !important;
          }

          .gsk-submit-btn {
            writing-mode: horizontal-tb !important;
            text-orientation: mixed !important;
            min-height: auto !important;
            /* Ekran boyunca uzamasin; icerigi kadar yetiyor */
            min-width: 200px !important;
            width: auto !important;
            padding: 12px 16px !important;
            font-size: 16px !important;
            border-radius: 8px !important;
            touch-action: manipulation;
            -webkit-tap-highlight-color: transparent;
          }

          .gsk-dialog {
            width: min(calc(100vw - 48px), 400px) !important;
            max-width: min(calc(100vw - 48px), 400px) !important;
            margin: 16px !important;
          }

          .gsk-dialog .MuiDialogContent-root {
            padding: 12px 16px !important;
          }

          .gsk-dialog .MuiDialogActions-root {
            padding: 8px 16px 16px !important;
          }

          .gsk-dialog .MuiDialogActions-root button {
            width: 100% !important;
          }
        }
      `}</style>
    </div>
  );
}

export default GunSonuKasa;